module.exports = function() {
  return new Worker(__webpack_public_path__ + "9bf4b630db8f37c050f3.worker.js");
};